import React, { Component } from 'react';
import StandardButton from './StandardButton';
import PropTypes from 'prop-types';
/**
 * @augments {Component<{onClick:func, display:string>}
 * @props {function} onClick - required
 * @props {string} display 
 */
class SubmitButton extends Component {
	render() { 
		const { onClick, display, classNameAdd } = this.props;
		return <StandardButton 
			onClick = { onClick } 
			classNameAdd = {'pt-intent-primary pt-icon-small-tick ' + classNameAdd}
		>
			{display}
		</StandardButton>
	}
}

SubmitButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	display: PropTypes.string,
	classNameAdd: PropTypes.string
}

SubmitButton.defaultProps = {
	display: 'Submit',
	classNameAdd: ''
}

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/SubmitButton.jsx